import { OAuthCounters } from '@recruitee/http-types';
import { createSingleEntityStore, PickActions } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<OAuthCounters>()('OAuthCounters');

const OAuthCountersActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  OAuthCountersActions,
  reducer as OAuthCountersReducer,
  namespace as OAuthCountersNamespace,
  selectors as OAuthCountersSelectors,
};
